import cn from 'classnames';

import './targetingCard.scss';

export interface TargetingCardProps {
  className?: string;
  icon: string;
  isSelected: boolean;
  label: string;
  onClick: () => void;
  subtitle?: string;
}

export function TargetingCard({ className, icon, isSelected, label, onClick, subtitle }: TargetingCardProps) {
  return (
    <button
      className={cn('targetingCard', className, { 'targetingCard--selected': isSelected })}
      onClick={onClick}
      type="button"
    >
      <i className={cn('targetingCard__icon', icon)} />
      <span className="targetingCard__content">
        <span className="targetingCard__label" title={label}>
          {label}
        </span>
        {subtitle && (
          <span className="targetingCard__subtitle" title={subtitle}>
            {subtitle}
          </span>
        )}
      </span>
    </button>
  );
}
